<template>
  <div class="agent-filter-form custom-wrapper">
    <div class="filter-wrapper">
      <el-form
        label-position="right"
        label-width="80px"
        ref="filterForm"
        :model="filterForm">

        <el-form-item label="代理商 ID" prop="agentid">
          <el-input
            v-model="filterForm.agentid"
            placeholder="请输入代理商 ID"
            @keyup.enter.native="onFilterSubmit">
          </el-input>
        </el-form-item>

        <el-form-item label="代理商名" prop="agentname">
          <el-input
            v-model="filterForm.agentname"
            placeholder="请输入代理商名称"
            @keyup.enter.native="onFilterSubmit">
          </el-input>
        </el-form-item>

      </el-form>

      <div class="submit">
        <el-button
          type="danger"
          size="medium"
          @click="onFilterSubmit">查询</el-button>
        <el-button
          size="medium"
          @click="resetFilters">重置</el-button>
        </div>
    </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'
import { SET_PAGE, SET_FILTERS } from '@/store/modules/table'

export default {
  nam: 'AgentFilterForm',
  data () {
    return {
      filterForm: {
        agentid: '',
        agentname: ''
      }
    }
  },
  methods: {
    ...mapMutations('table', [
      SET_PAGE,
      SET_FILTERS
    ]),

    onFilterSubmit () {
      this.setPage(1)
      this.setFilters(this.filterForm)

      this.$emit('filter')
    },
    resetFilters () {
      this.$refs['filterForm'].resetFields()

      this.filterForm.agentid = ''
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../assets/sass/base";

</style>



// WEBPACK FOOTER //
// src/components/user/AgentFilterForm.vue